import OperationsController from "../adapters/trip.controller";

const getTripOpened = async(payload) =>{
    const finalPayload={
        id: parseInt(payload)
    }
    const response = await OperationsController.getTripOpened(finalPayload)
    return response;
}


export default getTripOpened;